"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Reward_1 = __importDefault(require("../../../Icons/Notifications/Reward"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var CampaignName_1 = __importDefault(require("./CampaignName"));
var i18N = {
    en: {
        description: function (metadata) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "The ",
            react_1.default.createElement(CampaignName_1.default, { metadata: metadata }),
            " campaign has run out of funds.")); },
        title: 'Campaign Out of Funds'
    },
    es: {
        description: function (metadata) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "La campa\u00F1a ",
            react_1.default.createElement(CampaignName_1.default, { metadata: metadata }),
            " se ha quedado sin fondos.")); },
        title: 'Campaña sin fondos'
    },
    zh: {
        description: function (metadata) { return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(CampaignName_1.default, { metadata: metadata }),
            " \u6D3B\u52A8\u8D44\u91D1\u4E0D\u8DB3\u3002")); },
        title: '活动资金不足'
    }
};
/**
 * @deprecated Should start using the same component migrated to UI2.
 */
function CampaignOutOfFundsNotification(_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: {
            image: react_1.default.createElement(Reward_1.default, { width: "48", height: "48" })
        }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata))));
}
exports.default = CampaignOutOfFundsNotification;
